import React from 'react';
import './NavBar.scss';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaSearch, FaTimes } from 'react-icons/fa';
import iplogo from '../../IP-logo.png';
import MenuToggleButton from './MenuToggleButton';
import DropDownMenu from './DropDownMenu';


/**
 * NavBar Component.
 * Renders the navigation bar contained within the application.
 * 
 * Its state is usefull only for smaller devices (700 pixels and less). The state tracks
 * whether the menu button was clicked or not in order to bring the menu to the screen.
 * 
 */
class NavBar extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         menuClicked: false,
         showSearchField: false,
         search: '',
         searchType: props.searchType
      };

      this.numberCartClasses = 'number-cart number-cart-animation'
   }

   /**
    * This method handles the click event placed on the menu button. It changes this classe's
    * state from the opposite of its previous state when the button is clicked.
    * 
    * This method is not called within this class, rather it is passed as a prop to the
    * MenuToggleButton and DropDownMenu components.
    * 
    * MenutoggleButton will fire this method whenever the button is clicked, changing its
    * "menu" icon and opening the DropDownMenu component or changing its "close" icon and
    * closing the DropDownMenu component.
    * 
    * DropDownMenu will fire this method whenever one of its links is clicked in order to
    * close the menu and change the "close" icon to "menu" icon.
    */
   menuButtonClickHandler = () => {
      this.setState((previousState) => {
         return { menuClicked: !previousState.menuClicked };
      });
   }


   searchButtonClickHandler = () => {
      this.setState({
         showSearchField: !this.state.showSearchField
      });
   }


   /**
    * Renders the NavBar component
    */
   render() {

      return (
         <nav className="nav-bar container-fluid">
            <div className="row justify-content-around nav-bar-content">
               <div className="logo-heading">
                  <Link to="/" className="navbar-brand"><img src={iplogo} alt="Logo" /></Link>
                  
                  <Link to="/" className=""><h1>Inheritance<br/>Publications</h1></Link>
               </div>

               <div className="navbar-spacer"></div>

               {/** Mobile: The component that holds the "menu" and "close" buttons */}
               <MenuToggleButton clickHandler={this.menuButtonClickHandler} clicked={this.state.menuClicked} />

               {/** Mobile: The component that holds the link menu used */}
               <DropDownMenu cartStorage={this.props.cartStorage} clickHandler={this.menuButtonClickHandler} show={this.state.menuClicked}/>

               <div className="nav-links">
                  <ul className="nav-links-list">
                     <li className="nav-item">
                        <Link className="nav-link" to="/">Home</Link>
                     </li>
                     <li className="nav-item">
                        <Link className="nav-link" to="/products">Products</Link>
                     </li>
                     <li className="nav-item">
                        <Link className="nav-link" to="/about-us">About Us</Link>
                     </li>
                     <li className="nav-item">
                        <Link className="nav-link" to="/whats-new">What's New</Link>
                     </li>
                     <li className="nav-item">
                        <Link className="nav-link" to="/contact">Contact</Link>
                     </li>
                     <li className="nav-item">
                        {this.props.cartStorage.length > 0 ? <p id="number-cart" className={this.numberCartClasses}>{this.props.cartStorage.length}</p> : null}
                        <Link className="nav-link" to="/cart"><FaShoppingCart /></Link>
                     </li>
                     <li className="nav-item">
                        {!this.props.hideNavSearch ? <span className="nav-link" onClick={() => this.searchButtonClickHandler()}><FaSearch /></span> : null} 
                        {this.state.showSearchField && !this.props.hideNavSearch ?
                           <div className="nb-search d-flex flex-column">
                              <span className="nb-search-close" onClick={() => this.searchButtonClickHandler()}><FaTimes /></span>
                              <input type="text" placeholder="Search products..." onChange={e => this.props.setSearch(e.target.value)} value={this.props.search}/>
                              <div className="nv-search-type">

                                 <input id="nv-search-type-radio1" type="radio" name="nv-search-type" value="by title" onClick={() => this.props.setSearchType('by title')} onChange={() => {}} checked={this.props.searchType === 'by title'}/>
                                 <label htmlFor="nv-search-type-radio1">By title</label><br></br>

                                 <input id="nv-search-type-radio2" type="radio" name="nv-search-type" value="by author" onClick={() => this.props.setSearchType('by author')} onChange={() => {}} checked={this.props.searchType === 'by author'}/>
                                 <label htmlFor="nv-search-type-radio2">By author</label><br></br>

                              </div>
                              <Link to="/products"><button className="btn btn-secondary btn-block" onClick={() => this.searchButtonClickHandler()}>Search</button></Link>
                           </div> :
                           null
                        }
                     </li>
                  </ul>
               </div>
            </div>
         </nav>
      )
   }
}


export default NavBar
